export var EmployeeRoles;
(function (EmployeeRoles) {
    EmployeeRoles["SuperAdmin"] = "SuperAdmin";
    EmployeeRoles["Admin"] = "Admin";
    EmployeeRoles["Management"] = "Management";
    EmployeeRoles["Technician"] = "Technician";
})(EmployeeRoles || (EmployeeRoles = {}));
